import { css } from '@linaria/core';
import { row } from './row';

const lightTheme = `
  --color: #000;
  --border-color: #dcdcdd;
  --summary-border-color: #aaa;
  --background-color: hsl(0deg 0% 100%);
  --header-background-color: hsl(0deg 0% 97.5%);
  --row-hover-background-color: hsl(0deg 0% 96%);
  --row-selected-background-color: hsl(207deg 76% 92%);
  --row-selected-hover-background-color: hsl(207deg 76% 88%);

  --checkbox-color: hsl(207deg 100% 29%);
  --checkbox-focus-color: hsl(207deg 100% 69%);
  --checkbox-disabled-border-color: #ccc;
  --checkbox-disabled-background-color: #ddd;

  --selection-color: #66afe9;
  --selected-color: #DFE8F1;
  --dragging-color:  #dae1e7cc;
  --selecting-color: #ede6e6;
`;

const darkTheme = `
  --color: #ddd;
  --border-color: #1E2B32;
  --summary-border-color: #555;
  --background-color: #293842;
  --header-background-color: #30404d;
  --row-hover-background-color: darken(#293842, 4%);
  --row-selected-background-color: hsl(207deg 76% 42%);
  --row-selected-hover-background-color: hsl(207deg 76% 38%);

  --checkbox-color: hsl(207deg 100% 79%);
  --checkbox-focus-color: hsl(207deg 100% 89%);
  --checkbox-disabled-border-color: #000;
  --checkbox-disabled-background-color: #333;
  
  --selection-color: #66afe9;
  --selected-color:  #487295;
  --dragging-color:  #66aee92f;
  --selecting-color: #3b4b56;
`;

const root = css`
  ${lightTheme}
  --selection-color: #66afe9;
  --font-size: 12px;

  color-scheme: var(--color-scheme, light dark);

  // https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
  // We set a stacking context so internal elements don't render on top of external components.
  contain: strict;
  contain: size layout style paint;
  content-visibility: auto;
  height: 350px;
  border: 1px solid var(--border-color);
  box-sizing: border-box;
  overflow: auto;
  user-select: none;
  background-color: var(--background-color);
  color: var(--color);
  font-size: var(--font-size);

  // set stacking context in safari
  @supports not (contain: strict) {
    position: relative;
    z-index: 0;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  &.rdg-dark {
    --color-scheme: dark;
    ${darkTheme}
  }

  &.rdg-light {
    --color-scheme: light;
  }

  @media (prefers-color-scheme: dark) {
    &:not(.rdg-light) {
      ${darkTheme}
    }
  }
`;

export const rootClassname = `rdg ${root}`;

const focusSink = css`
  position: sticky;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  outline: 0;
`;

export const focusSinkClassname = `rdg-focus-sink ${focusSink}`;

const viewportDragging = css`
  &.${row} {
    cursor: move;
  }
`;

export const viewportDraggingClassname = `rdg-viewport-dragging ${viewportDragging}`;
